import React from "react";

import { Input } from "antd";

const CustomInput = ({ value, children, disabled = false, style = {}, ...props }) => {
  return (
    <Input
      data-tm-id="tt-trackking-number"
      bordered={false}
      disabled={disabled}
      value={value}
      style={{
        width: "100%",
        border: "0px",
        backgroundColor: "transparent",
        borderBottom: "1px solid #9B9B9B",
        ...style
      }}
      {...props}
    >
      {children}
    </Input>
  );
};

export { CustomInput };
